import cssModule from "@vercel/turbopack-next/internal/font/google/cssmodule.module.css?{%22path%22:%22_app.tsx%22,%22import%22:%22Instrument_Serif%22,%22arguments%22:[{%22subsets%22:[%22latin%22,%22latin-ext%22],%22weight%22:%22400%22,%22style%22:[%22normal%22,%22italic%22]}],%22variableName%22:%22display%22}";
const fontData = {
    className: cssModule.className,
    style: {
        fontFamily: "'Instrument Serif', 'Instrument Serif Fallback'",
        fontWeight: 400,

    },
};

if (cssModule.variable != null) {
    fontData.variable = cssModule.variable;
}

export default fontData;
